import { render, staticRenderFns } from "./OrderingResult.vue?vue&type=template&id=60ab421e&lang=pug&"
import script from "./OrderingResult.vue?vue&type=script&lang=js&"
export * from "./OrderingResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports